<template>
  <v-layout column>
    <v-card
      class="elevation-0 mt-3 mb-2"
      style="border: 1px solid rgba(0, 0, 0, 0.16);"
    >
      <v-card-text>
        <v-layout
          column
          align-center
        >
          <div>
            <span
              v-if="selectedRadioSpots.length > 0"
              class="mr-3"
            >
              <v-icon color="msr">music_note</v-icon>
              <span class="title grey--text text--darken-1 ml-1">{{
                selectedRadioSpots.length
              }}</span>
            </span>
            <span
              v-if="selectedTVSpotBundles.length > 0"
              class="mr-3"
            >
              <v-icon color="msr">tv</v-icon>
              <span class="title grey--text text--darken-1 ml-1">{{
                selectedTVSpotBundles.length
              }}</span>
            </span>
            <span
              v-if="selectedTickers.length > 0"
              class="mr-3"
            >
              <v-icon color="msr">sms</v-icon>
              <span class="title grey--text text--darken-1 ml-1">{{
                selectedTickers.length
              }}</span>
            </span>
          </div>
          <div class="mt-2 subheading">
            {{ $t('activateMultipleContentsCurrentSelectionInfo_1') }}
            <span
              class="msr--text help-anchor"
              :title="selectedContentsTooltip"
            >{{ selectedContents.length }} {{ $t('contents') }}</span>
            {{ $t('activateMultipleContentsCurrentSelectionInfo_2') }}
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
    <div
      v-if="showCompatibleContentExplanation"
      class="blue--text px-3 ml-auto"
    >
      {{ $t('activateMultipleContentsCurrentSelectionInfo_3') }}
    </div>
  </v-layout>
</template>

<script>
import {getMainTVSpotFromBundle} from '@/utils';

export default {
  props: {
    selectedContents: {
      type: Array[Object],
      required: true,
    },
    showCompatibleContentExplanation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedRadioSpots() {
      return this.selectedContents.filter(
        (content) => content.kind === 'radiospot'
      );
    },
    selectedTVSpotBundles() {
      return this.selectedContents.filter(
        (content) => content.kind === 'tvspotbundle'
      );
    },
    selectedTickers() {
      return this.selectedContents.filter(
        (content) => content.kind === 'ticker'
      );
    },
    selectedContentsTooltip() {
      const titles = this.selectedContents.map((content) => {
        if (content.kind === 'tvspotbundle') {
          const mainTvSpot = getMainTVSpotFromBundle(content);
          return 'TV: ' + mainTvSpot.title;
        } else if (content.kind === 'radiospot') {
          return 'Radio: ' + content.title;
        } else if (content.kind === 'ticker') {
          return 'Ticker: ' + content.message.substring(0, 10);
        }
      });
      return titles.sort().join('\n');
    },
  },
};
</script>

<style scoped>
.help-anchor {
  text-decoration: underline;
  cursor: help;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentSelectionInfo.vue